// @ts-nocheck
if (!window.videoObserver) {
  function loadVideo(video) {
    let source = video.querySelector('source')
    if (!source) {
      const sources = JSON.parse(video.getAttribute('data-srcs') || '[]')
      sources.forEach((src) => {
        source = document.createElement('source')
        source.setAttribute('type', src.type)
        source.setAttribute('src', src.src)
        video.appendChild(source)
        video.classList.remove('blur-sm')
      })
    }
  }

  window.videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio < 0.33 && !entry.target.paused) {
          entry.target.pause()
        } else if (entry.intersectionRatio >= 0.33 && entry.target.paused) {
          loadVideo(entry.target)
          entry.target.play()
        }
      })
    },
    { threshold: [0.1, 0.25, 0.5, 0.75, 0.9] }
  )

  const $$videos = document.querySelectorAll('[data-lazy-video]')
  $$videos.forEach(($video) => window.videoObserver.observe($video))

  const $$clickVideos = document.querySelectorAll('[data-lazy-video-click]')
  $$clickVideos.forEach(($video) => {
    const interactionHandler = () => {
      loadVideo($video)
      $video.play()
      $video.removeEventListener('click', interactionHandler)
      $video.removeEventListener('mouseover', interactionHandler)
    }

    $video.addEventListener('click', interactionHandler)
    $video.addEventListener('mouseover', interactionHandler)
  })
}
